import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import { isExternalVerticalActive } from '../../../../../utils';

import IconExchange from '../../../../../images/icons/misc/icon-exchange.svg';
import IconPredictions from '../../../../../images/icons/misc/icon-predictions.svg';

import styles from './ExternalVertical.module.scss';


const iconMapper = {
  Exchange: <IconExchange />,
  Predictions: <IconPredictions />,
};

const ExternalVertical = ({
  name,
  url,
  onClick = () => { },
  showLabel = true,
  icon = '',
  iconName = '',
  dataHook = '',
  openInNewTab = false
}) => {
  const Icon = iconName ? iconMapper[iconName] : null;

  const buttonClassName = classNames({
    [styles.verticalButton]: true,
    [styles['verticalButton--current']]: isExternalVerticalActive(url),
  });

  return (
    <div
      role="button"
      onClick={() => onClick({ url, openInNewTab })}
      className={buttonClassName}
      data-hook={dataHook}
    >
      <div className={styles.verticalContent}>
        {icon ?
          <img src={icon} alt={`${name}-button-icon`} className={styles.remoteIcon} />
          : Icon
        }
        {showLabel ? (
          <div>
            {name}
          </div>
        ) : null}
      </div>
    </div>
  );
};

ExternalVertical.propTypes = {
  name: PropTypes.string,
  url: PropTypes.string,
  onClick: PropTypes.func,
  showLabel: PropTypes.bool,
  icon: PropTypes.string,
  iconName: PropTypes.string,
  dataHook: PropTypes.string,
  openInNewTab: PropTypes.bool,
};

export default ExternalVertical;
